module.exports = __webpack_public_path__ + "static/media/floorplans-leaf.54480a82.svg";